import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { monthsIndexesWithou0 } from '../../../../Common/Util/getMonthsByYear';
import { useRegistersChartsDataContext } from './useRegistersChartsDataContext';

const useMonthlyEvolutionRegisters = () => {
    const { chartData } = useRegistersChartsDataContext();


    const categories = chartData.monthlyEvolutionRegisters.map((item) =>
        monthsIndexesWithou0[item.description] || item.description
    );

    const subtitles = ['Novos Cadastros', 'Atualizações', 'Recusas'];

    const series = subtitles.map((item) => {
        const data = categories.map((category) => {
            const found = chartData.monthlyEvolutionRegisters.find(
                (counter) => category === monthsIndexesWithou0[counter.description]
            );

            let value = 0;

            switch (item) {
                case 'Novos Cadastros':
                    value = found.novos_cadastros;
                    break;
                case 'Atualizações':
                    value = found.atualizacoes;
                    break;
                case 'Recusas':
                    value = found.recusas;
                    break;
                default:
                    value = 0;
                    break;
            }

            return Number(value);
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            stroke: {
                width: 2,
                colors: ['#fff']
            },
            xaxis: {
                categories: categories || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#333']
                },
                offsetX: 0,
                offsetY: -20
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useMonthlyEvolutionRegisters;
